import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

const initialState = {
    user: {
        nome: localStorage.nome
    },
    list: []
}

export default class Fiscal extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState }
    }

    componentDidMount() {
        const url = '/api/ficha/fiscal'
        const user = { ...this.state.user }
        axios.post(url, user)
            .then(resp => {
                this.setState({ list: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="text-center mx-auto">
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>PROCESSO</th>
                                <th>SITUAÇÃO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderRows() {
        return this.state.list.map(ficha => {
            return (
                <tr key={ficha.id}>
                    <td>{ficha.numero}</td>
                    <td>{ficha.setor}</td>
                    <td>
                        <Link to={`/documentos/${ficha._id}`} params={ficha}>
                            <button className="btn btn-warning">Abrir</button>
                        </Link>
                    </td>
                </tr>
            )
        })
    }
}